import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    padding: '0 1rem 0 0',
    height: pxToRem(layout.constants.commandBar.height),
    top: pxToRem(layout.constants.topNav.height),
    left: 0,
    backgroundColor: theme.palette.neutralWhite,
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    position: 'fixed',
    width: '100%',
    zIndex: 10,
    selectors: {
      '& .ms-CommandBar': {
        backgroundColor: theme.palette.neutralWhite,
        padding: 0,
      },
      '& .ms-Button': {
        backgroundColor: theme.palette.neutralWhite,
        fontSize: pxToRem(14),
        paddingLeft: '1rem',
        paddingRight: '1rem',
      },
      '& .ms-Button .ms-Icon': {
        margin: 0,
        fontSize: pxToRem(16),
        color: theme.palette.themePrimary,
      },
      '& .ms-CommandBar-secondaryCommand .ms-Button--hasMenu .ms-Icon': {
        margin: `0 0 0 ${pxToRem(8)}`,
      },
      '& .ms-Button:hover .ms-Icon': {
        color: theme.palette.themePrimary,
      },
      '& .ms-Button--commandBar.is-disabled': {
        backgroundColor: theme.palette.neutralWhite,
      },
      '& .ms-Button--commandBar.is-disabled .ms-Icon': {
        color: theme.palette.neutralWhite,
      },
    },
  },
  submenu: {
    backgroundColor: theme.palette.neutralWhite,
    selectors: {
      '& .ms-ContextualMenu-link': {
        fontWeight: 400,
        paddingLeft: '1rem',
        paddingRight: '1rem',
        minWidth: pxToRem(192),
      },
      '& .ms-Button:hover .ms-Icon': {
        color: theme.palette.themePrimary,
      },
    },
  },
  uploader: {
    display: 'none',
  },
  bundleCommands: {
    selectors: {
      '&.ms-Button--commandBar': {
        padding: '0',
      },
    },
  },
});
